export const formatPercentage = (value: number, decimals: number = 2) => {
    return value % 1 === 0
        ? `${value.toString()}%`
        : `${value.toFixed(decimals).replace(/\.?0+$/, '')}%`
}
